import { Component } from '@angular/core';
import { ErrorComponentComponent } from 'src/app/components/error-component/error-component.component';

@Component({
  selector: 'app-error-page',
  imports: [ErrorComponentComponent],
  templateUrl: './error-page.component.html',
  styleUrl: './error-page.component.scss',
})
export class ErrorPageComponent {}
